/// <reference types="vite/client" />

const env = {
  awsRegion: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN as string,
  get redirectSignIn() {
    return `${window.location.origin}/auth/callback`
  },
  get redirectSignOut() {
    return `${window.location.origin}/auth/signout`
  },
  apiEndpoint:
    (import.meta.env.VITE_API_ENDPOINT as string) || 'http://127.0.0.1:8008',
  bypassAuth:
    import.meta.env.VITE_BYPASS_AUTH &&
    import.meta.env.VITE_BYPASS_AUTH === 'true',
  isDev: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN as string,
  logrocketAppId: import.meta.env.VITE_LOGROCKET_ID as string,
  mixpanelRecordSessionsPercent: import.meta.env
    .VITE_MIXPANEL_RECORD_SESSIONS_PERCENT as string,
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string,
  stripePricingTableId: import.meta.env.VITE_STRIPE_PRICING_TABLE_ID as string,
}

export { env }

// Validate required environment variables
const requiredEnvVars = [
  'VITE_COGNITO_USER_POOL_ID',
  'VITE_COGNITO_CLIENT_ID',
  'VITE_COGNITO_DOMAIN',
  'VITE_REDIRECT_SIGN_IN',
  'VITE_REDIRECT_SIGN_OUT',
] as const

for (const envVar of requiredEnvVars) {
  if (!import.meta.env[envVar]) {
    console.error(`Missing required environment variable: ${envVar}`)
  }
}
